import React, { useState, useEffect, useRef } from 'react';
import CpcbLogo from '../assets/image/golden_jubilee.jpg'
import kumbhlogo from '../assets/image/kumbh-logo.png'
import MoefccLogo from '../assets/image/moef-logo-right.png'
import IndiaEmblem from '../assets/image/logo-india.9bec2f9c3f7ffa42dbc6.png'
import { Row, Col } from 'react-bootstrap'; // For Row and Col from Bootstrap
import "../assets/css/home-style.css";
import imageBanner from "../assets/image/IntroductionBanner.png"
import ShowGeoTubesData from "../components/ShowGeoTubesData";
import axios from "axios";

import { Link, useLocation } from 'react-router-dom';

const Home = () => {
  const location = useLocation();
  const [dataGeoTubes, setData] = useState([]);
  const [rowDevice, setRowDevice] = useState({});
  const [showModal, setShowModal] = useState(false);


  const [activeTab, setActiveTab] = useState('river');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [hits, setHits] = useState(0);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    // Axios config
    const axiosConfig = {
      withCredentials: true, // Handles credentials
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Insert a hit
    axios.post("https://cpcbepalab.in/visitor/index.php", {}, axiosConfig)
      .then(() => axios.get("https://cpcbepalab.in/visitor/view.php", axiosConfig))
      .then((response) => {
        if (response.data && response.data.hits !== undefined) {
          setHits(response.data.hits);
        }
      })
      .catch((error) => {
        console.error("CORS or network error:", error);
      });
  }, []);


  // useEffect(() => {
  //   // Load Google Analytics script
  //   const script = document.createElement("script");
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=G-ZBN5CW4W81";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   // Initialize Google Analytics
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() {
  //     window.dataLayer.push(arguments);
  //   }
  //   gtag("js", new Date());
  //   gtag("config", "G-ZBN5CW4W81");
  // }, []); // Run once on mount

  useEffect(() => {
    // Load Google Analytics script
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-L8EGFS2XHC";
    script.async = true;
    document.head.appendChild(script);

    // Initialize Google Analytics
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-L8EGFS2XHC');
    `;
    document.head.appendChild(inlineScript);
  }, []); // Run once on mount


  const tableData = [
    {
      "date": "12.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.45,
          "color": 5.0,
          "DO": 9.0,
          "temp": 15.0,
          "turbidity": 20.0,
          "COD": 9.54,
          "BOD": 2.44,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.41,
          "color": 5.0,
          "DO": 8.8,
          "temp": 15.0,
          "turbidity": 28.0,
          "COD": 9.44,
          "BOD": 2.36,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.48,
          "color": 10.0,
          "DO": 8.7,
          "temp": 16.0,
          "turbidity": 41.0,
          "COD": 8.65,
          "BOD": 2.16,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.52,
          "color": 10.0,
          "DO": 8.5,
          "temp": 17.0,
          "turbidity": 10.0,
          "COD": 14.9,
          "BOD": 3.74,
          "fecalColiform": 2000
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.63,
          "color": 5.0,
          "DO": 7.9,
          "temp": 16.0,
          "turbidity": 11.0,
          "COD": 22.8,
          "BOD": 5.24,
          "fecalColiform": 4500
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.87,
          "color": 5.0,
          "DO": 8.0,
          "temp": 17.0,
          "turbidity": 8.0,
          "COD": 12.8,
          "BOD": 4.52,
          "fecalColiform": 2000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.84,
          "color": 5.0,
          "DO": 8.1,
          "temp": 17.0,
          "turbidity": 6.3,
          "COD": 13.8,
          "BOD": 3.64,
          "fecalColiform": 4500
        }
      ]
    },
    {
      "date": "13.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.88,
          "color": 5.0,
          "DO": 9.1,
          "temp": 16.0,
          "turbidity": 26.0,
          "COD": 11.9,
          "BOD": 3.42,
          "fecalColiform": 23000
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.93,
          "color": 10.0,
          "DO": 7.0,
          "temp": 16.0,
          "turbidity": 40.0,
          "COD": 8.95,
          "BOD": 2.22,
          "fecalColiform": 2000
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.91,
          "color": 10.0,
          "DO": 8.9,
          "temp": 15.0,
          "turbidity": 45.0,
          "COD": 19.9,
          "BOD": 4.48,
          "fecalColiform": 2000
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.92,
          "color": 10.0,
          "DO": 9.2,
          "temp": 16.0,
          "turbidity": 9.6,
          "COD": 14.2,
          "BOD": 3.94,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.09,
          "color": 10.0,
          "DO": 9.5,
          "temp": 16.5,
          "turbidity": 12.0,
          "COD": 13.6,
          "BOD": 3.58,
          "fecalColiform": 33000
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.11,
          "color": 5.0,
          "DO": 9.0,
          "temp": 17.0,
          "turbidity": 6.1,
          "COD": 15.4,
          "BOD": 4.82,
          "fecalColiform": 11000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.08,
          "color": 5.0,
          "DO": 9.0,
          "temp": 17.0,
          "turbidity": 9.07,
          "COD": 16.5,
          "BOD": 4.7,
          "fecalColiform": 2000
        }
      ]
    },
    {
      "date": "14.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.64,
          "color": 5.0,
          "DO": 9.2,
          "temp": 15.0,
          "turbidity": 31.0,
          "COD": "BDL",
          "BOD": "BDL",
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.84,
          "color": 5.0,
          "DO": 8.9,
          "temp": 15.0,
          "turbidity": 31.0,
          "COD": 5.7,
          "BOD": 1.63,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.88,
          "color": 5.0,
          "DO": 8.8,
          "temp": 15.0,
          "turbidity": 40.0,
          "COD": 5.5,
          "BOD": 1.25,
          "fecalColiform": 4500
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.86,
          "color": 5.0,
          "DO": 7.8,
          "temp": 15.0,
          "turbidity": 20.6,
          "COD": 11.5,
          "BOD": 2.18,
          "fecalColiform": 11000
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.97,
          "color": 5.0,
          "DO": 7.5,
          "temp": 15.0,
          "turbidity": 15.0,
          "COD": 8.54,
          "BOD": 2.49,
          "fecalColiform": 17000
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.19,
          "color": 5.0,
          "DO": 8.2,
          "temp": 15.0,
          "turbidity": 8.0,
          "COD": 5.5,
          "BOD": 1.06,
          "fecalColiform": 33000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.17,
          "color": 10.0,
          "DO": 8.3,
          "temp": 15.0,
          "turbidity": 7.3,
          "COD": 6,
          "BOD": 1.66,
          "fecalColiform": 2000
        }
      ]
    },
    {
      "date": "15.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.21,
          "color": 5.0,
          "DO": 9.0,
          "temp": 14.0,
          "turbidity": 28.7,
          "COD": "<5.0",
          "BOD": "<1.0",
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.19,
          "color": 5.0,
          "DO": 8.9,
          "temp": 14.0,
          "turbidity": 33.9,
          "COD": "<5.0",
          "BOD": "<1.0",
          "fecalColiform": 7800
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.11,
          "color": 5.0,
          "DO": 8.9,
          "temp": 14.0,
          "turbidity": 45.0,
          "COD": 5.5,
          "BOD": 1.09,
          "fecalColiform": 13000
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.19,
          "color": 5.0,
          "DO": 8.5,
          "temp": 14.0,
          "turbidity": 50.0,
          "COD": "<5.0",
          "BOD": "<1.0",
          "fecalColiform": 6800
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.2,
          "color": 5.0,
          "DO": 8.6,
          "temp": 14.0,
          "turbidity": 15.0,
          "COD": "<5.0",
          "BOD": "<1.0",
          "fecalColiform": 4500
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.22,
          "color": 5.0,
          "DO": 8.9,
          "temp": 14.0,
          "turbidity": 12.4,
          "COD": 6.3,
          "BOD": "<1.0",
          "fecalColiform": 2000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.16,
          "color": 5.0,
          "DO": 8.8,
          "temp": 14.0,
          "turbidity": 13.6,
          "COD": "<5.0",
          "BOD": "<1.0",
          "fecalColiform": 2000
        }
      ]
    },
    {
      "date": "19.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.81,
          "color": 10.0,
          "DO": 9.4,
          "temp": 15.0,
          "turbidity": 14.0,
          "COD": 8.92,
          "BOD": 1.76,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.18,
          "color": 10.0,
          "DO": 9.0,
          "temp": 15.0,
          "turbidity": 30.0,
          "COD": 10.9,
          "BOD": 4.52,
          "fecalColiform": 7800
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.22,
          "color": 10.0,
          "DO": 8.8,
          "temp": 15.0,
          "turbidity": 40.0,
          "COD": 5.95,
          "BOD": 1.36,
          "fecalColiform": 4500
        }
      ]
    },
    {
      "date": "20.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.47,
          "color": 10.0,
          "DO": 8.6,
          "temp": 15.0,
          "turbidity": 14.0,
          "COD": 9.92,
          "BOD": 2.46,
          "fecalColiform": 49000
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.34,
          "color": 10.0,
          "DO": 8.9,
          "temp": 15.0,
          "turbidity": 13.0,
          "COD": 6.15,
          "BOD": "<1.0",
          "fecalColiform": 7800
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.88,
          "color": 5.0,
          "DO": 8.4,
          "temp": 16.0,
          "turbidity": 5.8,
          "COD": 6.94,
          "BOD": 1.78,
          "fecalColiform": 23000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.72,
          "color": 5.0,
          "DO": 8.2,
          "temp": 16.0,
          "turbidity": 6.8,
          "COD": 7.94,
          "BOD": 2.15,
          "fecalColiform": 33000
        }
      ]
    },
    {
      "date": "24.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 6.95,
          "color": 10.0,
          "DO": 10.2,
          "temp": 20.0,
          "turbidity": 130.0,
          "COD": 32,
          "BOD": 5.02,
          "fecalColiform": 7900
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.48,
          "color": 10.0,
          "DO": 10.0,
          "temp": 20.0,
          "turbidity": 120.0,
          "COD": 32,
          "BOD": 5.18,
          "fecalColiform": 13000
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.88,
          "color": 10.0,
          "DO": 10.5,
          "temp": 20.1,
          "turbidity": 190.0,
          "COD": 33.6,
          "BOD": 7.42,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.92,
          "color": 15.0,
          "DO": 9.7,
          "temp": 20.2,
          "turbidity": 45.0,
          "COD": 22.1,
          "BOD": 4.08,
          "fecalColiform": 3300
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.82,
          "color": 10.0,
          "DO": 8.5,
          "temp": 19.9,
          "turbidity": 28.0,
          "COD": 22,
          "BOD": 4.12,
          "fecalColiform": 17000
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.84,
          "color": 15.0,
          "DO": 8.2,
          "temp": 20.1,
          "turbidity": 4.6,
          "COD": 12.5,
          "BOD": 2.96,
          "fecalColiform": 780
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.92,
          "color": 10.0,
          "DO": 8.2,
          "temp": 20.3,
          "turbidity": 5.9,
          "COD": 21.6,
          "BOD": 3.8,
          "fecalColiform": 450
        }
      ]
    },
    {
      "date": "28.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.46,
          "color": 5.0,
          "DO": 9.0,
          "temp": 17.5,
          "turbidity": 39.0,
          "COD": 17.1,
          "BOD": 3.37,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.82,
          "color": 10.0,
          "DO": 8.8,
          "temp": 17.5,
          "turbidity": 28.0,
          "COD": 13.4,
          "BOD": 2.7,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.77,
          "color": 5.0,
          "DO": 8.7,
          "temp": 17.5,
          "turbidity": 12.0,
          "COD": 14.8,
          "BOD": 2.34,
          "fecalColiform": 450
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.83,
          "color": 10.0,
          "DO": 7.8,
          "temp": 18.2,
          "turbidity": 7.0,
          "COD": 13,
          "BOD": 2.48,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.07,
          "color": 10.0,
          "DO": 8.6,
          "temp": 17.5,
          "turbidity": 50.0,
          "COD": 11.5,
          "BOD": 3.84,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.09,
          "color": 5.0,
          "DO": 8.5,
          "temp": 18.0,
          "turbidity": 6.7,
          "COD": 11.2,
          "BOD": 3.14,
          "fecalColiform": 780
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.08,
          "color": 5.0,
          "DO": 7.9,
          "temp": 18.1,
          "turbidity": 2.1,
          "COD": 14.7,
          "BOD": 3.88,
          "fecalColiform": 7900
        }
      ]
    },
    {
      "date": "29.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.27,
          "color": 10.0,
          "DO": 9.2,
          "temp": 17.5,
          "turbidity": 40.0,
          "COD": 15.4,
          "BOD": 3.13,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.5,
          "color": 10.0,
          "DO": 8.9,
          "temp": 17.5,
          "turbidity": 30.0,
          "COD": 13.1,
          "BOD": 2.78,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.35,
          "color": 5.0,
          "DO": 8.5,
          "temp": 17.5,
          "turbidity": 10.3,
          "COD": 12.6,
          "BOD": 3.13,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.46,
          "color": 10.0,
          "DO": 8.9,
          "temp": 17.5,
          "turbidity": 60.0,
          "COD": 15.1,
          "BOD": 2.26,
          "fecalColiform": 2300
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.35,
          "color": 5.0,
          "DO": 8.3,
          "temp": 17.5,
          "turbidity": 13.0,
          "COD": 11,
          "BOD": 3.18,
          "fecalColiform": 400
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.31,
          "color": 5.0,
          "DO": 8.3,
          "temp": 18.0,
          "turbidity": 4.4,
          "COD": 11.8,
          "BOD": 3.44,
          "fecalColiform": 13000
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.27,
          "color": 10.0,
          "DO": 8.0,
          "temp": 18.0,
          "turbidity": 8.0,
          "COD": 13.7,
          "BOD": 3.85,
          "fecalColiform": 7900
        }
      ]
    },
    {
      "date": "30.01.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.85,
          "color": 5.0,
          "DO": 9.5,
          "temp": 17.0,
          "turbidity": 40.0,
          "COD": 20.1,
          "BOD": 4.38,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.77,
          "color": 10.0,
          "DO": 9.3,
          "temp": 17.0,
          "turbidity": 29.0,
          "COD": 19.9,
          "BOD": 4.2,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.58,
          "color": 5.0,
          "DO": 9.0,
          "temp": 17.0,
          "turbidity": 15.0,
          "COD": 14.6,
          "BOD": 2.18,
          "fecalColiform": 13000
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 5.0,
          "DO": 9.2,
          "temp": 17.5,
          "turbidity": 22.0,
          "COD": 14.3,
          "BOD": 2.74,
          "fecalColiform": 2400
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.51,
          "color": 10.0,
          "DO": 8.8,
          "temp": 17.0,
          "turbidity": 13.0,
          "COD": 11.8,
          "BOD": 3.3,
          "fecalColiform": 3300
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.46,
          "color": 5.0,
          "DO": 8.6,
          "temp": 17.5,
          "turbidity": 2.9,
          "COD": 11,
          "BOD": 1.32,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.68,
          "color": 10.0,
          "DO": 8.6,
          "temp": 17.5,
          "turbidity": 3.4,
          "COD": 16.6,
          "BOD": 2.16,
          "fecalColiform": 2300
        }
      ]
    },
    {
      "date": "02.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.02,
          "color": 10.0,
          "DO": 9.6,
          "temp": 19.0,
          "turbidity": 40.0,
          "COD": 11.6,
          "BOD": 2.21,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.32,
          "color": 10.0,
          "DO": 9.3,
          "temp": 19.0,
          "turbidity": 29.0,
          "COD": 15.4,
          "BOD": 2.4,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.49,
          "color": 10.0,
          "DO": 9.0,
          "temp": 19.0,
          "turbidity": 10.0,
          "COD": 19.5,
          "BOD": 2.56,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.18,
          "color": 10.0,
          "DO": 8.4,
          "temp": 19.1,
          "turbidity": 14.0,
          "COD": 18.9,
          "BOD": 2.55,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 10.0,
          "DO": 8.2,
          "temp": 19.2,
          "turbidity": 4.6,
          "COD": 28.5,
          "BOD": 5.54,
          "fecalColiform": 200
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.18,
          "color": 10.0,
          "DO": 8.9,
          "temp": 19.6,
          "turbidity": 11.0,
          "COD": 17.5,
          "BOD": 2.63,
          "fecalColiform": 3300
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.28,
          "color": 10.0,
          "DO": 8.6,
          "temp": 19.2,
          "turbidity": 60.0,
          "COD": 15.4,
          "BOD": 3.15,
          "fecalColiform": 4900
        }
      ]
    },
    {
      "date": "03.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.74,
          "color": 10.0,
          "DO": 9.4,
          "temp": 19.0,
          "turbidity": 6.0,
          "COD": 16.7,
          "BOD": 2.53,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.81,
          "color": 10.0,
          "DO": 9.2,
          "temp": 19.0,
          "turbidity": 50.0,
          "COD": 16.5,
          "BOD": 2.43,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.47,
          "color": 10.0,
          "DO": 8.4,
          "temp": 19.7,
          "turbidity": 15.0,
          "COD": 20.7,
          "BOD": 2.67,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 10.0,
          "DO": 8.1,
          "temp": 19.6,
          "turbidity": 30.0,
          "COD": 14.3,
          "BOD": 2.74,
          "fecalColiform": 1300
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.93,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.0,
          "turbidity": 6.1,
          "COD": 26.6,
          "BOD": 5.12,
          "fecalColiform": 450
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.4,
          "color": 10.0,
          "DO": 9.2,
          "temp": 19.4,
          "turbidity": 8.2,
          "COD": 18.5,
          "BOD": 3,
          "fecalColiform": 450
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.46,
          "color": 10.0,
          "DO": 9.1,
          "temp": 19.2,
          "turbidity": 40.0,
          "COD": 14.6,
          "BOD": 2.48,
          "fecalColiform": 200
        }
      ]
    },
    {
      "date": "04.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.37,
          "color": 10.0,
          "DO": 9.5,
          "temp": 19.5,
          "turbidity": 3.0,
          "COD": 15.9,
          "BOD": 2.47,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 10.0,
          "DO": 9.3,
          "temp": 19.5,
          "turbidity": 39.0,
          "COD": 16.5,
          "BOD": 2.52,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.27,
          "color": 10.0,
          "DO": 8.3,
          "temp": 19.5,
          "turbidity": 4.3,
          "COD": 16.2,
          "BOD": 2.81,
          "fecalColiform": 11000
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.41,
          "color": 10.0,
          "DO": 8.0,
          "temp": 19.2,
          "turbidity": 3.0,
          "COD": 14.6,
          "BOD": 2.07,
          "fecalColiform": 7900
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.41,
          "color": 15.0,
          "DO": 8.8,
          "temp": 19.5,
          "turbidity": 30.0,
          "COD": 14.2,
          "BOD": 3.32,
          "fecalColiform": 4900
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.48,
          "color": 10.0,
          "DO": 8.2,
          "temp": 19.3,
          "turbidity": 23.0,
          "COD": 15.9,
          "BOD": 2.45,
          "fecalColiform": 3300
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.32,
          "color": 15.0,
          "DO": 8.1,
          "temp": 19.3,
          "turbidity": 13.0,
          "COD": 12.1,
          "BOD": 2.51,
          "fecalColiform": 4900
        }
      ]
    },
    {
      "date": "08.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.28,
          "color": 10.0,
          "DO": 8.9,
          "temp": 19.0,
          "turbidity": 40.0,
          "COD": 22.4,
          "BOD": 2.36,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.32,
          "color": 10.0,
          "DO": 8.6,
          "temp": 19.0,
          "turbidity": 40.0,
          "COD": 22,
          "BOD": 3.08,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.41,
          "color": 10.0,
          "DO": 8.5,
          "temp": 19.0,
          "turbidity": 40.0,
          "COD": 21.8,
          "BOD": 2.84,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.92,
          "color": 5.0,
          "DO": 8.0,
          "temp": 19.1,
          "turbidity": 24.0,
          "COD": 10.1,
          "BOD": 1.7,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.84,
          "color": 10.0,
          "DO": 8.1,
          "temp": 19.2,
          "turbidity": 22.0,
          "COD": 19.9,
          "BOD": 3.18,
          "fecalColiform": 680
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.29,
          "color": 10.0,
          "DO": 8.0,
          "temp": 19.2,
          "turbidity": 11.0,
          "COD": 17.3,
          "BOD": 1.74,
          "fecalColiform": 2200
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 7.96,
          "color": 10.0,
          "DO": 7.8,
          "temp": 19.2,
          "turbidity": 21.0,
          "COD": 19.9,
          "BOD": 2.46,
          "fecalColiform": 780
        }
      ]
    },
    {
      "date": "12.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.47,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.9,
          "turbidity": 24.0,
          "COD": 20.4,
          "BOD": 2.8,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.14,
          "color": 10.0,
          "DO": 8.6,
          "temp": 19.8,
          "turbidity": 28.0,
          "COD": 21.3,
          "BOD": 2.56,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.34,
          "color": 15.0,
          "DO": 8.5,
          "temp": 19.9,
          "turbidity": 40.0,
          "COD": 20.8,
          "BOD": 2.58,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.19,
          "color": 10.0,
          "DO": 8.9,
          "temp": 20.0,
          "turbidity": 11.0,
          "COD": 18.5,
          "BOD": 2.84,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.25,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.8,
          "turbidity": 15.0,
          "COD": 23,
          "BOD": 3.38,
          "fecalColiform": 1700
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.29,
          "color": 10.0,
          "DO": 8.9,
          "temp": 19.6,
          "turbidity": 5.8,
          "COD": 18,
          "BOD": 2.78,
          "fecalColiform": 450
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.26,
          "color": 10.0,
          "DO": 8.9,
          "temp": 20.1,
          "turbidity": 11.0,
          "COD": 19.5,
          "BOD": 2.88,
          "fecalColiform": 3300
        }
      ]
    },
    {
      "date": "13.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.7,
          "color": 10.0,
          "DO": 8.7,
          "temp": 19.9,
          "turbidity": 29.0,
          "COD": 21.4,
          "BOD": 2.62,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.87,
          "color": 10.0,
          "DO": 8.6,
          "temp": 19.5,
          "turbidity": 29.0,
          "COD": 22.1,
          "BOD": 2.58,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 8.77,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.8,
          "turbidity": 40.0,
          "COD": 21.5,
          "BOD": 2.64,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.9,
          "turbidity": 5.6,
          "COD": 20.8,
          "BOD": 2.1,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.33,
          "color": 10.0,
          "DO": 8.7,
          "temp": 19.8,
          "turbidity": 18.0,
          "COD": 28.8,
          "BOD": 4.22,
          "fecalColiform": 1100
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.23,
          "color": 10.0,
          "DO": 8.8,
          "temp": 19.9,
          "turbidity": 9.2,
          "COD": 18.6,
          "BOD": 2.06,
          "fecalColiform": 680
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.27,
          "color": 15.0,
          "DO": 8.9,
          "temp": 19.9,
          "turbidity": 12.0,
          "COD": 20.4,
          "BOD": 2.44,
          "fecalColiform": 2300
        }
      ]
    },
    {
      "date": "17.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 7.45,
          "color": 10.0,
          "DO": 9.0,
          "temp": 18.5,
          "turbidity": 35.0,
          "COD": 21.9,
          "BOD": 2.2,
          "fecalColiform": "<1.8"
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Once a day",
          "pH": 7.04,
          "color": 10.0,
          "DO": 9.5,
          "temp": 18.3,
          "turbidity": 30.0,
          "COD": 22.9,
          "BOD": 2.36,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Before shashtri bridge near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Once a day",
          "pH": 7.16,
          "color": 5.0,
          "DO": 9.8,
          "temp": 18.6,
          "turbidity": 30.0,
          "COD": 23.9,
          "BOD": 2.68,
          "fecalColiform": 2200
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.4,
          "color": 5.0,
          "DO": 9.6,
          "temp": 18.0,
          "turbidity": 12.0,
          "COD": 16,
          "BOD": 2.64,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Once a day",
          "pH": 8.42,
          "color": 10.0,
          "DO": 9.4,
          "temp": 18.6,
          "turbidity": 15.0,
          "COD": 15,
          "BOD": 2.48,
          "fecalColiform": 200
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Once a day",
          "pH": 8.32,
          "color": 10.0,
          "DO": 9.2,
          "temp": 18.0,
          "turbidity": 11.0,
          "COD": 17,
          "BOD": 2.4,
          "fecalColiform": 1700
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Once a day",
          "pH": 8.43,
          "color": 5.0,
          "DO": 8.9,
          "temp": 17.8,
          "turbidity": 8.6,
          "COD": 18,
          "BOD": 2.44,
          "fecalColiform": 450
        }
      ]
    },
    {
      "date": "21.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Morning",
          "pH": 8.26,
          "color": 5.0,
          "DO": 9.9,
          "temp": 21.0,
          "turbidity": 18.0,
          "COD": 13.6,
          "BOD": 2.16,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.31,
          "color": 5.0,
          "DO": 9.5,
          "temp": 21.2,
          "turbidity": 20.0,
          "COD": 17.5,
          "BOD": 2.74,
          "fecalColiform": 2200
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Morning",
          "pH": 8.0,
          "color": 5.0,
          "DO": 8.3,
          "temp": 21.0,
          "turbidity": 20.0,
          "COD": 14.7,
          "BOD": 2.18,
          "fecalColiform": 1300
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Evening",
          "pH": 8.02,
          "color": 5.0,
          "DO": 8.6,
          "temp": 21.0,
          "turbidity": 22.0,
          "COD": 14.2,
          "BOD": 2.56,
          "fecalColiform": 780
        },
        {
          "river": "Ganga",
          "name": "Near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Morning",
          "pH": 7.78,
          "color": 5.0,
          "DO": 8.2,
          "temp": 20.8,
          "turbidity": 30.0,
          "COD": 16.7,
          "BOD": 2.32,
          "fecalColiform": 680
        },
        {
          "river": "Ganga",
          "name": "Near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Evening",
          "pH": 7.87,
          "color": 5.0,
          "DO": 8.1,
          "temp": 20.9,
          "turbidity": 25.0,
          "COD": 16.4,
          "BOD": 2.34,
          "fecalColiform": 1400
        },
        {
          "river": "Ganga",
          "name": "At Shastri Bridge",
          "monitoringFrequency": "Morning",
          "pH": 7.31,
          "color": 5.0,
          "DO": 8.5,
          "temp": 21.0,
          "turbidity": 35.0,
          "COD": 15.7,
          "BOD": 2.4,
          "fecalColiform": 200
        },
        {
          "river": "Ganga",
          "name": "At Shastri Bridge",
          "monitoringFrequency": "Evening",
          "pH": 7.58,
          "color": 5.0,
          "DO": 8.3,
          "temp": 21.0,
          "turbidity": 30.0,
          "COD": 18,
          "BOD": 2.58,
          "fecalColiform": 450
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Morning",
          "pH": 8.35,
          "color": 10.0,
          "DO": 8.5,
          "temp": 22.0,
          "turbidity": 30.0,
          "COD": 21,
          "BOD": 2.6,
          "fecalColiform": 1300
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Evening",
          "pH": 8.34,
          "color": 10.0,
          "DO": 8.4,
          "temp": 22.9,
          "turbidity": 31.0,
          "COD": 22.5,
          "BOD": 2.74,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "Someshwar Ghat",
          "monitoringFrequency": "Morning",
          "pH": 8.37,
          "color": 10.0,
          "DO": 8.9,
          "temp": 22.1,
          "turbidity": 27.0,
          "COD": 22,
          "BOD": 2.92,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "Someshwar Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.23,
          "color": 10.0,
          "DO": 8.2,
          "temp": 22.6,
          "turbidity": 17.0,
          "COD": 25,
          "BOD": 2.6,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "At DPS",
          "monitoringFrequency": "Morning",
          "pH": 8.22,
          "color": 10.0,
          "DO": 8.9,
          "temp": 21.8,
          "turbidity": 32.0,
          "COD": 14,
          "BOD": 2.36,
          "fecalColiform": 1300
        },
        {
          "river": "Ganga",
          "name": "At DPS",
          "monitoringFrequency": "Evening",
          "pH": 8.27,
          "color": 10.0,
          "DO": 8.9,
          "temp": 22.5,
          "turbidity": 22.0,
          "COD": 19,
          "BOD": 2.46,
          "fecalColiform": 1400
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Morning",
          "pH": 8.35,
          "color": 10.0,
          "DO": 8.5,
          "temp": 22.0,
          "turbidity": 24.0,
          "COD": 13,
          "BOD": 1.96,
          "fecalColiform": 2100
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.05,
          "color": 10.0,
          "DO": 8.2,
          "temp": 22.0,
          "turbidity": 5.2,
          "COD": 16,
          "BOD": 2.36,
          "fecalColiform": 450
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Morning",
          "pH": 8.2,
          "color": 10.0,
          "DO": 8.8,
          "temp": 22.5,
          "turbidity": 20.0,
          "COD": 26,
          "BOD": 2.92,
          "fecalColiform": 2100
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Evening",
          "pH": 8.4,
          "color": 10.0,
          "DO": 8.5,
          "temp": 22.5,
          "turbidity": 11.0,
          "COD": 25,
          "BOD": 2.66,
          "fecalColiform": 1300
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Morning",
          "pH": 8.44,
          "color": 10.0,
          "DO": 9.1,
          "temp": 22.1,
          "turbidity": 11.0,
          "COD": 24,
          "BOD": 2.6,
          "fecalColiform": 2200
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Evening",
          "pH": 8.36,
          "color": 10.0,
          "DO": 8.9,
          "temp": 22.6,
          "turbidity": 11.0,
          "COD": 22,
          "BOD": 2.72,
          "fecalColiform": 2400
        }
      ]
    },
    {
      "date": "22.02.2025",
      "locations": [
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Morning",
          "pH": 7.96,
          "color": 5.0,
          "DO": 9.2,
          "temp": 21.0,
          "turbidity": 14.0,
          "COD": 12,
          "BOD": 1.96,
          "fecalColiform": 2300
        },
        {
          "river": "Ganga",
          "name": "Shringverpur Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.34,
          "color": 5.0,
          "DO": 9.5,
          "temp": 21.2,
          "turbidity": 14.0,
          "COD": 15,
          "BOD": 2.24,
          "fecalColiform": 2200
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Morning",
          "pH": 8.46,
          "color": 10.0,
          "DO": 9.8,
          "temp": 20.9,
          "turbidity": 30.0,
          "COD": 12,
          "BOD": 2.06,
          "fecalColiform": 2200
        },
        {
          "river": "Ganga",
          "name": "Lord Curzon bridge",
          "monitoringFrequency": "Evening",
          "pH": 8.37,
          "color": 10.0,
          "DO": 8.8,
          "temp": 21.3,
          "turbidity": 25.0,
          "COD": 16,
          "BOD": 2.42,
          "fecalColiform": 2100
        },
        {
          "river": "Ganga",
          "name": "Near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Morning",
          "pH": 8.44,
          "color": 10.0,
          "DO": 8.3,
          "temp": 20.8,
          "turbidity": 35.0,
          "COD": 10.5,
          "BOD": 2.26,
          "fecalColiform": 1400
        },
        {
          "river": "Ganga",
          "name": "Near Nagvasuki Mandir Pantoon Pul No. 15",
          "monitoringFrequency": "Evening",
          "pH": 8.47,
          "color": 10.0,
          "DO": 8.5,
          "temp": 21.3,
          "turbidity": 35.0,
          "COD": 14,
          "BOD": 2.64,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "At Shastri Bridge",
          "monitoringFrequency": "Morning",
          "pH": 8.38,
          "color": 10.0,
          "DO": 8.2,
          "temp": 21.5,
          "turbidity": 20.0,
          "COD": 15.5,
          "BOD": 2.26,
          "fecalColiform": 1100
        },
        {
          "river": "Ganga",
          "name": "At Shastri Bridge",
          "monitoringFrequency": "Evening",
          "pH": 8.26,
          "color": 10.0,
          "DO": 8.4,
          "temp": 20.5,
          "turbidity": 25.0,
          "COD": 19.6,
          "BOD": 2.88,
          "fecalColiform": 1400
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Morning",
          "pH": 8.36,
          "color": 10.0,
          "DO": 8.0,
          "temp": 22.3,
          "turbidity": 30.0,
          "COD": 12,
          "BOD": 1.86,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "Sangam",
          "monitoringFrequency": "Evening",
          "pH": 8.28,
          "color": 10.0,
          "DO": 8.3,
          "temp": 22.2,
          "turbidity": 30.0,
          "COD": 18,
          "BOD": 2.42,
          "fecalColiform": 2200
        },
        {
          "river": "Ganga",
          "name": "Someshwar Ghat",
          "monitoringFrequency": "Morning",
          "pH": 8.29,
          "color": 10.0,
          "DO": 8.6,
          "temp": 22.0,
          "turbidity": 28.0,
          "COD": 20,
          "BOD": 2.36,
          "fecalColiform": 1100
        },
        {
          "river": "Ganga",
          "name": "Someshwar Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.42,
          "color": 10.0,
          "DO": 8.0,
          "temp": 22.1,
          "turbidity": 10.0,
          "COD": 22,
          "BOD": 2.6,
          "fecalColiform": 2100
        },
        {
          "river": "Ganga",
          "name": "At DPS",
          "monitoringFrequency": "Morning",
          "pH": 8.46,
          "color": 10.0,
          "DO": 8.4,
          "temp": 22.9,
          "turbidity": 25.0,
          "COD": 21,
          "BOD": 2.3,
          "fecalColiform": 1700
        },
        {
          "river": "Ganga",
          "name": "At DPS",
          "monitoringFrequency": "Evening",
          "pH": 8.61,
          "color": 10.0,
          "DO": 8.1,
          "temp": 23.0,
          "turbidity": 17.0,
          "COD": 22,
          "BOD": 2.7,
          "fecalColiform": 2100
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Morning",
          "pH": 8.37,
          "color": 10.0,
          "DO": 8.3,
          "temp": 22.5,
          "turbidity": 25.0,
          "COD": 18,
          "BOD": 2.46,
          "fecalColiform": 1200
        },
        {
          "river": "Ganga",
          "name": "Deeha Ghat",
          "monitoringFrequency": "Evening",
          "pH": 8.37,
          "color": 10.0,
          "DO": 8.0,
          "temp": 22.5,
          "turbidity": 22.0,
          "COD": 22,
          "BOD": 2.82,
          "fecalColiform": 1700
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Morning",
          "pH": 8.35,
          "color": 10.0,
          "DO": 7.8,
          "temp": 22.4,
          "turbidity": 16.0,
          "COD": 19,
          "BOD": 2.58,
          "fecalColiform": 2100
        },
        {
          "river": "Yamuna",
          "name": "Old Naini Bridge",
          "monitoringFrequency": "Evening",
          "pH": 8.32,
          "color": 10.0,
          "DO": 8.3,
          "temp": 22.2,
          "turbidity": 12.0,
          "COD": 20,
          "BOD": 2.66,
          "fecalColiform": 2100
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Morning",
          "pH": 8.24,
          "color": 10.0,
          "DO": 8.1,
          "temp": 21.9,
          "turbidity": 32.0,
          "COD": 19.8,
          "BOD": 2.56,
          "fecalColiform": 1100
        },
        {
          "river": "Yamuna",
          "name": "Before confluence to river Ganga at Sangam",
          "monitoringFrequency": "Evening",
          "pH": 8.44,
          "color": 10.0,
          "DO": 8.1,
          "temp": 22.5,
          "turbidity": 20.0,
          "COD": 22,
          "BOD": 2.66,
          "fecalColiform": 780
        }
      ]
    }
  ]

  const stpData = [
    { location: 'Numayadahi', flow: '56', datetime: '31.12.2024', pH: '7.05', bod: '6.27', cod: '28.5', tss: '5.40', coliform: '<1.8' },
    { location: 'Phaphamau', flow: '18', datetime: '31.12.2024', pH: '7.65', bod: '15.5', cod: '42.0', tss: '6.80', coliform: '7.8x10^3' },
    { location: 'Naini, Old', flow: '94', datetime: '01.01.2025', pH: '7.41', bod: '17.7', cod: '43.5', tss: '10.6', coliform: '<1.8' },
    { location: 'Naini, New', flow: '45', datetime: '01.01.2025', pH: '7.79', bod: '17.5', cod: '42.4', tss: '21.2', coliform: '<1.8' },
    { location: 'Jhunsi', flow: '15', datetime: '01.01.2025', pH: '7.89', bod: '16.0', cod: '52.0', tss: '12.8', coliform: '<1.8' },
    { location: 'Salori, Old', flow: '37', datetime: '01.01.2025', pH: '7.58', bod: '15.9', cod: '54.3', tss: '13.0', coliform: '<1.8' },
    { location: 'Salori, New', flow: '13', datetime: '01.01.2025', pH: '7.39', bod: '6.93', cod: '29.7', tss: '2.86', coliform: '<1.8' },
    { location: 'Rajapur', flow: '77', datetime: '06.01.2025', pH: '7.85', bod: '17.6', cod: '53.2', tss: '17.2', coliform: '<1.8' },
    { location: 'Ponghat', flow: '15', datetime: '07.01.2025', pH: '7.83', bod: '23.7', cod: '60.8', tss: '32.8', coliform: '<1.8' },
    { location: 'Kodra', flow: '33', datetime: '07.01.2025', pH: '7.93', bod: '24.3', cod: '72.3', tss: '21.4', coliform: '<1.8' },
    { location: 'Numayadahi', flow: '57.76', datetime: '21.01.2025', pH: '7.52', bod: '8.36', cod: '27.9', tss: '16.2', coliform: '<1.8' },
    { location: 'Phaphamau', flow: '17.92', datetime: '20.01.2025', pH: '7.12', bod: '16.8', cod: '52.3', tss: '16.4', coliform: '<1.8' },
    { location: 'Naini, Old', flow: '123.15', datetime: '21.01.2025', pH: '7.69', bod: '14.7', cod: '56.2', tss: '16.4', coliform: '<1.8' },
    { location: 'Naini, New', flow: '48.63', datetime: '20.01.2025', pH: '7.40', bod: '6.75', cod: '32.9', tss: '21.2', coliform: '<1.8' },
    { location: 'Jhunsi', flow: '17.34', datetime: '21.01.2025', pH: '7.44', bod: '15.4', cod: '57.4', tss: '24.8', coliform: '<1.8' },
    { location: 'Salori, Old', flow: '39', datetime: '21.01.2025', pH: '7.33', bod: '17.4', cod: '60.8', tss: '17.6', coliform: '<1.8' },
    { location: 'Salori, New', flow: '13.89', datetime: '21.01.2025', pH: '7.44', bod: '6.32', cod: '21.7', tss: '3.4', coliform: '<1.8' },
    { location: 'Rajapur', flow: '88.9', datetime: '20.01.2025', pH: '7.43', bod: '28.0', cod: '85.6', tss: '23.6', coliform: '<1.8' },
    { location: 'Ponghat', flow: '16.82', datetime: '21.01.2025', pH: '7.45', bod: '32.0', cod: '111', tss: '54.4', coliform: '<1.8' },
    { location: 'Kodra', flow: '32.52', datetime: '21.01.2025', pH: '7.48', bod: '3.76', cod: '14.3', tss: '11.6', coliform: '<1.8' }
  ];



  // const geoTubesData = [
  //   { geoTube: "Sadar Bazar Drain", date: "18.01.2025", ph: 7.63, do: 5.5, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "Rajapur Drain", date: "18.01.2025", ph: 7.38, do: 4.0, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "ADA Colony/Jwala Devi Drain", date: "18.01.2025", ph: 7.30, do: 5.5, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "Jondhwal Drain", date: "18.01.2025", ph: 7.19, do: 6.0, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "Shivkuti Drain", date: "18.01.2025", ph: 7.49, do: 2.0, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "Salori Drain", date: "18.01.2025", ph: 7.40, do: 3.0, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" },
  //   { geoTube: "Sasur Khaderi River", date: "19.01.2025", ph: 7.49, do: 1.0, tss: "RA", cod: "RA", bod: "RA", coliform: "RA" }
  // ]
  // const geoTubesData = [
  //   { geoTube: "Sadar Bazar Drain", date: "18.01.2025", ph: 7.63, do: 5.5, tss: 39.2, cod: 109, bod: 43.8, coliform: "2.0 x10^3" },
  //   { geoTube: "Rajapur Drain", date: "18.01.2025", ph: 7.38, do: 4.0, tss: 41.2, cod: 83.1, bod: 22.2, coliform: "3.5 x10^6" },
  //   { geoTube: "ADA Colony/Jwala Devi Drain", date: "18.01.2025", ph: 7.30, do: 5.5, tss: 59.4, cod: 80.4, bod: 22.0, coliform: "5.4 x10^6" },
  //   { geoTube: "Jondhwal Drain", date: "18.01.2025", ph: 7.19, do: 6.0, tss: 68.0, cod: 132, bod: 36.2, coliform: "9.2 x10^6" },
  //   { geoTube: "Shivkuti Drain", date: "18.01.2025", ph: 7.49, do: 2.0, tss: 82.8, cod: 68.0, bod: 22.8, coliform: "<1.8" },
  //   { geoTube: "Salori Drain", date: "18.01.2025", ph: 7.40, do: 3.0, tss: 40.4, cod: 66.1, bod: 31.5, coliform: "3.5 x10^6" },
  //   { geoTube: "Sasur Khaderi River", date: "19.01.2025", ph: 7.49, do: 1.0, tss: 70.0, cod: 41.4, bod: 14.9, coliform: "9.2x10^6" },
  //   { geoTube: "Sadar Bazar Drain", date: "06.02.2025", ph: 7.42, do: 5.2, tss: 60.1, cod: 117, bod: 42.8, coliform: "3.3×10^3" },
  //   { geoTube: "Rajapur Drain", date: "06.02.2025", ph: 7.24, do: 5.3, tss: 50.6, cod: 88.9, bod: 35.3, coliform: "2.8×10^4" },
  //   { geoTube: "ADA Colony/Jwala Devi Drain", date: "06.02.2025", ph: 7.11, do: 6.3, tss: 18.6, cod: 38.2, bod: 15.6, coliform: "1.7×10^4" },
  //   { geoTube: "Jondhwal Drain", date: "06.02.2025", ph: 7.29, do: 5.2, tss: 149, cod: 152, bod: 59.2, coliform: "9.4×10^4" },
  //   { geoTube: "Shivkuti Drain", date: "06.02.2025", ph: 7.37, do: 7.5, tss: 31, cod: 79.6, bod: 19.8, coliform: "1.4×10^5" },
  //   { geoTube: "Salori Drain", date: "06.02.2025", ph: 7.36, do: 4.0, tss: 15, cod: 67, bod: 13.6, coliform: "3.5×10^4" },
  //   { geoTube: "Sasur Khaderi River", date: "05.02.2025", ph: 7.38, do: 4.2, tss: 7.92, cod: 71.5, bod: 19.4, coliform: "1.7×10^4" }
  // ];

  const geoTubesData = [
    { geoTube: "Sadar Bazar Drain", date: "18.01.2025", ph: 7.63, do: 5.5, tss: 39.2, cod: 109, bod: 43.8, coliform: "2.0 x10^3" },
    { geoTube: "Rajapur Drain", date: "18.01.2025", ph: 7.38, do: 4.0, tss: 41.2, cod: 83.1, bod: 22.2, coliform: "3.5 x10^6" },
    { geoTube: "ADA Colony/Jwala Devi Drain", date: "18.01.2025", ph: 7.30, do: 5.5, tss: 59.4, cod: 80.4, bod: 22.0, coliform: "5.4 x10^6" },
    { geoTube: "Jondhwal Drain", date: "18.01.2025", ph: 7.19, do: 6.0, tss: 68.0, cod: 132, bod: 36.2, coliform: "9.2 x10^6" },
    { geoTube: "Shivkuti Drain", date: "18.01.2025", ph: 7.49, do: 2.0, tss: 82.8, cod: 68.0, bod: 22.8, coliform: "<1.8" },
    { geoTube: "Salori Drain", date: "18.01.2025", ph: 7.40, do: 3.0, tss: 40.4, cod: 66.1, bod: 31.5, coliform: "3.5 x10^6" },
    { geoTube: "Sasur Khaderi River", date: "19.01.2025", ph: 7.49, do: 1.0, tss: 70.0, cod: 41.4, bod: 14.9, coliform: "9.2x10^6" }
  ];


  const tabs = [
    { id: 'river', label: 'River Water Quality' },
    { id: 'stp', label: 'Performance of Sewage Treatment Plant' },
    { id: 'geoTubes', label: 'Outlet of Wastewater Treatment from Geo-Tubes (Manual)' },
    { id: 'geoTubesApi', label: 'Waste Water Treatment With GeoTubes' },
    { id: 'stpOcems', label: 'Performance of Sewage Treatment Plants (OCEMS)', link: 'https://rtdms.cpcb.gov.in/kumbhmela/#/l/kumbh-mela' },
    // { id: 'geoTubesLink', label: 'Waste Water Treatment With GeoTubes', link: 'https://mahakumbh.azurewebsites.net/' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const url = "/api/2.0/devices/account/mahakumbh";
      const headers = {
        "Ocp-Apim-Subscription-Key": "2293bfaf145a49869f496ecbe4e68948",
        "Client-Id": "01588577-66dd-4dc8-9ba1-a51e9788171d",
        "Client-Secret": "zQp8Q~kLdF~jc_~~QRWWICcHpn~nGamcs.-CIdv0",
        "Content-Type": "application/json",
      };

      try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
          const errorText = await response.text(); // Get error details
          throw new Error(`HTTP error! Status: ${response.status} - ${errorText}`);
        }
        const result = await response.json();
        setData(result); // Log the result
      } catch (error) {
        console.error("Error fetching data:", error.message); // Log detailed error
        console.error(error); // Log the full error object
      }
    }
    fetchData();
  }, []);


  const [deviceId, setDeviceId] = useState(null);

  const handleLocationClick = (id) => {
    setDeviceId(id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDeviceId(null);
  };

  return (


    <div className="home-page">

      {/* <showGeoTubesModal showModal={showModal}
        handleCloseModal={handleCloseModal} /> */}

      <ShowGeoTubesData
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        deviceId={deviceId}
      />

      <Row className="align-items-center py-2">
        <Col md={3} className="text-center">
          <img
            src={IndiaEmblem}
            alt="India Emblem"
            style={{
              // height: '70px',
              width: '60px',
              backgroundColor: 'white',
              padding: '5px',
              objectFit: 'contain',
            }}
            className="me-2"
          />
          <img
            src={CpcbLogo}
            alt="CPCB Logo"
            style={{
              // height: '100px',
              width: '120px',
              backgroundColor: 'white',
              padding: '5px',
              objectFit: 'contain',
            }}
            className="me-2"
          />
          <img
            src={MoefccLogo}
            alt="MoEFCC Logo"
            style={{
              // height: '70px',
              width: '90px',
              backgroundColor: 'white',
              padding: '5px',
              objectFit: 'contain',
              marginLeft: "-15px"
            }}
            className="me-2"
          />
        </Col>

        <Col className='text-center kumbh-text'>
          <div className='kumbhlogo'>
            <img src={kumbhlogo} style={{ width: "90px", fontWeight: 700 }} />
          </div>

          <div className='kumbhtext'>
            <h2>Maha Kumbh</h2>
            <p>(Water Quality Data)</p>
          </div>
        </Col>

        <Col md={3} className='text-end' style={{ marginRight: '20px' }}>
          <h3 style={{ marginBottom: '5px' }}>Central Pollution Control Board</h3>
          <p>Ministry of Environment, Forest and Climate Change<br />
            Government of India
          </p>
        </Col>
      </Row>

      <Row className="header-nav" style={{ marginBottom: 0 }}>
        <Col className="text-center">
          <div className='container-fluid px-4 px-lg-5' >
            <ul>
              <li><Link to='/' className='active'>Home</Link></li>
              <li><Link to='about'>Kumbh Mela</Link></li>
              <li><Link to='/login'>Login</Link></li>
            </ul>
          </div>
        </Col>
      </Row>

      <div className="container-fluid banner-container">
        <div className="row">
          <div className="col-md-12 banner">
            <img src={imageBanner} alt="Kumbh Mela Banner" />
            <p className="banner-text">महा कुंभ 2025</p>
          </div>
        </div>
      </div>

      <div className="container-fluid px-4 px-lg-5 content-body">

        <div className='row'>
          <div className='col-md-9'>
            <div className='box home-box'>
              <div className="tabs-container">
                {/* <div className={`tab ${activeTab === 'river' ? 'active' : ''}`} onClick={() => handleTabClick('river')}>
                  <span>River Water Quality</span>
                </div>
                <div className={`tab ${activeTab === 'stp' ? 'active' : ''}`} onClick={() => handleTabClick('stp')}>
                  <span>Performance of Sewage Treatment Plant</span>
                </div>
                <div className={`tab ${activeTab === 'geoTubes' ? 'active' : ''}`} onClick={() => handleTabClick('geoTubes')}>
                  <span>Outlet of Wastewater Treatment from Geo-Tubes (Manual)</span>
                </div>
                <div className={`tab ${activeTab === 'geoTubesApi' ? 'active' : ''}`} onClick={() => handleTabClick('geoTubesApi')}>
                  <span>OutWith GeoTubes</span>
                </div>
                <div className="tab">
                  <a href="https://rtdms.cpcb.gov.in/kumbhmela/#/l/kumbh-mela" target="_blank"><span>Performance of Sewage Treatment Plants (OCEMS)</span></a>
                </div>
                <div className="tab" >
                  <a href="https://mahakumbh.azurewebsites.net/" target="_blank"><span>Waste Water Treatment With GeoTubes</span></a>
                </div> */}

                {tabs.map((tab) => (
                  tab.link ? (
                    <div className="tab" key={tab.id}>
                      <a href={tab.link} target="_blank" rel="noopener noreferrer">
                        <span>{tab.label}</span>
                      </a>
                    </div>
                  ) : (
                    <div
                      className={`tab ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => handleTabClick(tab.id)}
                      key={tab.id}
                    >
                      <span>{tab.label}</span>
                    </div>
                  )
                ))}

              </div>

              <div className="tab-content">
                <div id="river" className={`tab-pane fade ${activeTab === 'river' ? 'in active' : ''}`}>

                  <div className="table-container">
                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>River</th>
                          <th>Location</th>
                          <th>Monitoring Frequency</th>
                          <th>pH (6.5 - 8.5)</th>
                          <th>Color (Hazen)</th>
                          <th>DO (≥ 5 mg/l)</th>
                          <th>Temp (°C)</th>
                          <th>Turbidity (NTU)</th>
                          <th>COD (mg/l)</th>
                          <th>BOD (≤ 3 mg/l)</th>
                          <th>Fecal Coliform (≤ 2500 MPN/100ml)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row) => {
                          const rowSpan = row.locations.length; // Determining how many rows the date should span
                          return row.locations.map((loc, index) => (
                            <tr key={`${row.date}-${loc.name}`}>
                              {index === 0 && (
                                <td rowSpan={rowSpan}>{row.date}</td> // Only add date cell on the first index
                              )}
                              <td>{loc.river}</td>
                              <td>{loc.name}</td>
                              <td>{loc.monitoringFrequency}</td>
                              <td>{loc.pH}</td>
                              <td>{loc.color}</td>
                              <td>{loc.DO}</td>
                              <td>{loc.temp}</td>
                              <td>{loc.turbidity}</td>
                              <td>{loc.COD}</td>
                              <td>{loc.BOD}</td>
                              <td>{loc.fecalColiform}</td>
                            </tr>
                          ));
                        })}
                        <tr>
                          <td colSpan={11}><strong>Disclaimer:</strong>  The data represents a snapshot of water quality at a specific location and time and may vary significantly depending upon factors such as upstream anthropogenic activities, rate of flow, depth of sampling, time of sampling, river current and mixing of currents, sampling location and such other multiple factors. As a result, these values reflect water quality parameters at the exact time and place and may not fully represent the overall characteristics of the river, therefore, not necessarily reflecting the overall river water quality throughout the river stretch.</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>

                </div>



                <div id="geoTubesApi" className={`tab-pane fade ${activeTab === 'geoTubesApi' ? 'in active' : ''}`}>
                  <table className="table-container">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataGeoTubes.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <button
                              style={{
                                background: "none",
                                border: "none",
                                color: "blue",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => handleLocationClick(row.deviceId)}
                            >
                              {row.location}
                            </button>
                          </td>
                          {/* <td>{row.location}</td> */}
                          <td>{row.status}</td>
                          <td>{row.type}</td>
                          <td>{row.location} , Maha Kumbh Mela 2025</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>




                <div id="drain" className={`tab-pane fade ${activeTab === 'geoTubes' ? 'in active' : ''}`}>
                  <table className="table-container">
                    <thead>
                      <tr>
                        <th>Geo-tube</th>
                        <th>Date</th>
                        <th>PH</th>
                        <th>DO</th>
                        <th>TSS (mg/L)</th>
                        <th>COD (mg/L)</th>
                        <th>BOD (mg/L)</th>
                        <th>Faecal Coliform (MPN/100ml)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {geoTubesData.map((row, index) => (
                        <tr key={index}>
                          <td>{row.geoTube}</td>
                          <td>{row.date}</td>
                          <td>{row.ph}</td>
                          <td>{row.do}</td>
                          <td>{row.tss}</td>
                          <td>{row.cod}</td>
                          <td>{row.bod}</td>
                          <td>{row.coliform}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div id="stp" className={`tab-pane fade ${activeTab === 'stp' ? 'in active' : ''}`}>
                  <div className="table-container">
                    <table>
                      <thead>
                        <tr>
                          <th>S. No.</th>
                          <th>Location</th>
                          <th>Flow (MLD)</th>
                          <th>Date</th>
                          <th>pH</th>
                          <th>BOD (mg/L)</th>
                          <th>COD (mg/L)</th>
                          <th>TSS (mg/L)</th>
                          <th>Faecal Coliform (MPN/100ml)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stpData.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.location}</td>
                            <td>{row.flow}</td>
                            <td>{row.datetime}</td>
                            <td>{row.pH}</td>
                            <td>{row.bod}</td>
                            <td>{row.cod}</td>
                            <td>{row.tss}</td>
                            <td>{row.coliform}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='box'>
              <h3>Bathing Dates</h3>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Occasion</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>13 January 2025</td>
                    <td>Paush Purnima</td>
                  </tr>
                  <tr>
                    <td>14 January 2025</td>
                    <td>Makar Sankranti</td>
                  </tr>
                  <tr>
                    <td>29 January 2025</td>
                    <td>Mauni Amavasya</td>
                  </tr>
                  <tr>
                    <td>3 February 2025</td>
                    <td>Basant Panchami</td>
                  </tr>
                  <tr>
                    <td>12 February 2025</td>
                    <td>Maghi Purnima</td>
                  </tr>
                  <tr>
                    <td>26 February 2025</td>
                    <td>Maha Shivaratri</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>





      </div>

      <Row className="align-items-center py-2 footer">
        <Col className="text-center ">
          <p>
            Designed and Developed by @CPCB
            {/* <span style={{ float: "right", marginRight: "10rem" }}>
              <strong>Total Visitors:</strong> {hits}
            </span> */}
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
